<template>
  <v-card class="mb-8" elevation="0">
    <v-card-text>
      <v-row>
        <!-- LEVA STRANA: Prenos limita -->
        <v-col cols="12" md="6">
          <div class="subtitle-1 font-weight-bold mb-4">
            <v-icon left>mdi-transfer-right</v-icon>
            {{ $t("rollover_unused_limits") }}
          </div>

          <v-card outlined class="pa-4">
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="config.rollover_policy.allow_transfer"
                  :label="$t('allow_rollover_to_next_period')"
                  dense
                  :true-value="true"
                  :false-value="false"
                  hide-details
                  class="mt-0"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-expand-transition>
              <div v-if="config.rollover_policy.allow_transfer" class="mt-4">
                <v-row>
                  <v-col cols="12">
                    <dropdown
                      v-model="config.rollover_policy.settings.transfer_period"
                      :label="$t('rollover_period')"
                      :items="rolloverPeriodOptions"
                      outlined
                      dense
                      :hint="$t('how_often_unused_limit_transfers')"
                      persistent-hint
                      :readonly="readonly"
                    />
                  </v-col>
                  <v-col cols="12">
                    <text-field
                      v-model="config.rollover_policy.settings.transfer_limit_value"
                      :label="$t('max_rollover_amount')"
                      type="number"
                      :suffix="restaurantCurrency"
                      outlined
                      dense
                      :hint="$t('leave_empty_for_unlimited')"
                      persistent-hint
                      :readonly="readonly"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>

        <!-- DESNA STRANA: Prekoračenje limita -->
        <v-col cols="12" md="6">
          <div class="subtitle-1 font-weight-bold mb-4">
            {{ $t("what_happens_when_limit_exceeded") }}
          </div>

          <div>
            <selectable-card
              v-for="(type, index) in overLimitTypes"
              :key="index"
              :value="type.value"
              :current-value="config.rollover_policy.block_order"
              :icon="type.icon"
              :icon-color="type.color"
              :title="$t(type.i18nKey)"
              :description="$t(type.descKey)"
              :last="index === overLimitTypes.length - 1"
              @select="config.rollover_policy.block_order = $event"
              :readonly="readonly"
            >
              <!-- Slot za allow_orders (false) -->
              <v-card
                v-if="!config.rollover_policy.block_order"
                outlined
                class="mt-3 ml-8 pa-3"
              >
                <div class="subtitle-2 mb-3">
                  <v-icon left small>mdi-transfer</v-icon>
                  {{ $t("debt_handling") }}
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      v-model="config.rollover_policy.settings.carry_debt_to_next_month"
                      :true-value="true"
                      :false-value="false"
                      :label="$t('carry_debt_to_next_month')"
                      dense
                      hide-details
                      class="mt-0"
                      :readonly="readonly"
                    />
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <v-row
                    v-if="config.rollover_policy.settings.carry_debt_to_next_month"
                    class="mt-2"
                  >
                    <v-col cols="12">
                      <text-field
                        v-model="config.rollover_policy.settings.max_debt_value"
                        :label="$t('max_debt')"
                        type="number"
                        :suffix="restaurantCurrency"
                        :hint="$t('max_debt_hint')"
                        persistent-hint
                        :readonly="readonly"
                      />
                    </v-col>
                  </v-row>
                </v-expand-transition>

                <v-divider class="my-4" />

                <div class="subtitle-2 mb-3">
                  <v-icon left small>mdi-bell</v-icon>
                  {{ $t("notification_settings") }}
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-switch
                      v-model="
                        config.rollover_policy.settings.notification_settings.notify_user
                      "
                      :true-value="true"
                      :false-value="false"
                      :label="$t('notify_user_on_exceed')"
                      dense
                      hide-details
                      class="mt-0"
                      :readonly="readonly"
                    />
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <v-row
                    v-if="
                      config.rollover_policy.settings.notification_settings.notify_user
                    "
                    class="mt-2"
                  >
                    <v-col cols="12">
                      <text-field
                        v-model="
                          config.rollover_policy.settings.notification_settings.message
                        "
                        :label="$t('notification_message')"
                        outlined
                        dense
                        :hint="$t('message_shown_to_user_on_exceed')"
                        persistent-hint
                        :readonly="readonly"
                      />
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </v-card>
            </selectable-card>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectableCard from "../cards/SelectableCard.vue";
import { OVER_LIMIT_TYPES } from "@/utils/limitHelpers";

export default {
  name: "Step4OverLimit",
  components: {
    SelectableCard,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    overLimitTypes() {
      return OVER_LIMIT_TYPES;
    },
    rolloverPeriodOptions() {
      return [
        { text: this.$t("daily"), value: "day" },
        { text: this.$t("weekly"), value: "week" },
        { text: this.$t("monthly"), value: "month" },
      ];
    },
  },
};
</script>
